export const RECORDING_STATES = {
  PROMPT: "Prompt",
  RECORD: "Record",
  PAUSED: "Paused",
  DOWNLOAD: "Download",
  LOADING: "Loading",
  ERROR: "Error",
};

export const DEFAULT_TRANSCRIPTION_DATA = {
  transcript: null,
  facts: null,
  soapNotes: null,
  audioDuration: 0,
  audioFileName: "",
  patientId: null,
  isProcessing: false,
  estimatedProgress: 0,
  currentMilestone: "",
  elapsedTime: 0,
  shouldShowResults: false,
};

export const SUPPORTED_AUDIO_FORMATS = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
  "audio/ogg;codecs=opus",
  "audio/ogg",
  "audio/wav",
];

export const FALLBACK_AUDIO_FORMATS = [
  "audio/webm",
  "audio/mp4",
  "audio/ogg",
  "audio/wav",
];

export const TIMER_UPDATE_INTERVAL = 1000; // 1 second
export const MINUTE_MS = 60000; // 1 minute in milliseconds
/** Max encoded audio blob size allowed for uploads and external recorder saves (frontend guard). */
export const MAX_AUDIO_UPLOAD_BYTES = 2 * 1024 * 1024 * 1024; // 2 GiB
export const BACKUP_INTERVAL_MS = 20000; // 20 seconds
export const CHUNK_SEND_DELAY_MS = 500; // 500ms delay between chunk sends
export const RECORDING_CHUNK_TIMESLICE = 2000; // 2 seconds for MediaRecorder chunks

export const DEFAULT_AUDIO_BITRATE = 16000; // 16kbps for good quality/compatibility balance
export const RECORD_TIME_ALERT_MINUTES = 5; // Alert user after 5 minutes of recording

export const WEBSOCKET_TIMEOUT_MS = 10000; // 10 seconds timeout for WebSocket connections
export const DURATION_CALCULATION_TIMEOUT_MS = 5000; // 5 seconds timeout for duration calculation

export const MINUTE_TO_SECONDS = 60;
export const SECONDS_IN_HOUR = 3600;

// File extensions based on MIME types
export const FILE_EXTENSIONS = {
  "audio/webm": "webm",
  "audio/mp4": "mp4",
  "audio/wav": "wav",
  "audio/ogg": "ogg",
};

export const TRANSCRIPTION_MILESTONES = {
  AUTHENTICATING: "Authenticating",
  CREATING_SESSION: "Creating Session",
  UPLOADING_AUDIO: "Uploading Audio",
  PROCESSING_AUDIO: "Processing Audio",
  CREATING_TRANSCRIPT: "Creating Transcript",
  EXTRACTING_FACTS: "Extracting Facts",
  GENERATING_SOAP: "Generating SOAP Notes",
  FINALIZING: "Finalizing",
  COMPLETE: "Complete",
};

export const CREDIT_ESTIMATION = {
  PER_MINUTE: 0.00879,
  MINIMUM_CREDIT: 0.001,
};
